const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    title,
    image,
    button,
    hrefLink,
    hideButton,
    margin,
    containerized,
    imagePosition,
    space,
    addTitle,
    addImage,
  } = attributes;

  return (
    <section
      className={`GridCards ${margin} ${space} ${
        addImage ? '' : 'withoutImage'
      }`}
    >
      <div className={`${containerized ? 'Container' : ''}`}>
        {addTitle && (
          <RichText.Content
            tagName="h2"
            className={`Typography title-4 center color-blue-dark margin-large`}
            value={title}
          />
        )}

        <div className={`GridCards-wrap ${imagePosition}`}>
          <div className="GridCards-sep">
            <div className="GridCards-sep-wrap">
              <InnerBlocks.Content />

              {button && (
                <div className="GridCards-button-wrap">
                  <a
                    title="Button"
                    href={hrefLink}
                    className={`Button ButtonPlans ${
                      hideButton ? 'hidden' : ''
                    }`}
                  >
                    {button}
                  </a>
                </div>
              )}
            </div>
          </div>

          {addImage && (
            <div className={`GridCards-sep GridCards-image-wrap`}>
              <figure className={`GridCards-image`}>
                <img
                  src={image.src}
                  title={image.alt}
                  width={image.width}
                  height={image.height}
                  alt={image.alt}
                  class="MainFeatured-news-image"
                />
              </figure>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Save;
